import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const DocumentsSchemas = {
    Documents: zod.object({
        page: zodPage,
        limit: zodLimit(),
    }),
};
